import { PageJumpType } from "@/enum/PageJumpType";

const state = {
  cacheViewArr: [],
};

const getters = {};

const mutations = {
  // SET_DRAG_ORIGIN_WHITELIST(state, { dragOriginWhitelist } = {}) {
  //   state.dragOriginWhitelist = dragOriginWhitelist;
  // },
  ADD_CACHE_VIEW(state, { fullPath, name }) {
    const index = state.cacheViewArr.findIndex(
      (item) => item.fullPath === fullPath
    );
    if (index >= 0) {
      //  后退，并删除后面的
      state.cacheViewArr.splice(index + 1);
      return PageJumpType.back.value;
    } else {
      // 前进
      state.cacheViewArr.push({
        fullPath,
        name,
      });
      return PageJumpType.forward.value;
    }
  },
};

const actions = {
  // getDragOriginWhitelist({ commit, state }) {
  //   if (state.dragOriginWhitelist) return state.dragOriginWhitelist;
  //   const dragOriginWhitelist = getDragOriginWhitelist();
  //   commit("SET_DRAG_ORIGIN_WHITELIST", { dragOriginWhitelist });
  //   return dragOriginWhitelist;
  // },
  addCacheView({ commit }, { fullPath, name }) {
    return commit("ADD_CACHE_VIEW", { fullPath, name });
  },
};

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions,
};
